
import { eq, function as fn, map, option } from 'fp-ts'
import { DeepReadonly } from 'ts-essentials'
import Vue, { VueConstructor } from 'vue'
import { ServiceProvideOtpResponseError } from '@/api/definitions'
import { AuthnOtpProvisionFlowIndicator, AuthnOtpProvisionFlowError } from '@/redux/modules/authn/actions'
import { AuthnOtpProvision } from '@/redux/modules/authn/selectors'
import { remoteDataMappedErrorIndicator } from '@/components/form_validators'

const fromDomainError = (error: DeepReadonly<AuthnOtpProvisionFlowError>): DeepReadonly<ServiceProvideOtpResponseError> => error.error
const otpIncorrectIndicator = remoteDataMappedErrorIndicator(ServiceProvideOtpResponseError.INVALIDCODE, fromDomainError)
const otpMustRecoverIndicator = remoteDataMappedErrorIndicator(ServiceProvideOtpResponseError.ATTEMPTSEXHAUSTED, fromDomainError)

const INDICATOR_TO_MESSAGE = new Map<AuthnOtpProvisionFlowIndicator, string>([
  [AuthnOtpProvisionFlowIndicator.MAKING_REQUEST, 'Making request'],
  [AuthnOtpProvisionFlowIndicator.DECRYPTING_DATA, 'Decrypting data']
])

interface Mixins {
  untouchedSinceDispatch: boolean;
  authnOtpProvision: DeepReadonly<AuthnOtpProvision>;
}

export default (Vue as VueConstructor<Vue & Mixins>).extend({
  props: ['otp', 'authnOtpProvision'],
  data () {
    return {
      untouchedSinceDispatch: false
    }
  },
  validations: {
    otp: {
      correct () {
        return !otpIncorrectIndicator(this.authnOtpProvision, this.untouchedSinceDispatch)
      },
      lenient () {
        return !otpMustRecoverIndicator(this.authnOtpProvision, this.untouchedSinceDispatch)
      }
    }
  },
  computed: {
    otpErrors () {
      return {
        [this.$t('OTP_CODE_INCORRECT') as string]: !this.$v.otp.correct,
        [this.$t('OTP_ATTEMPTS_EXHAUSTED') as string]: !this.$v.otp.lenient
      }
    },
    indicatorMessage (): string | null {
      return fn.pipe(
        this.authnOtpProvision.indicator,
        option.chain((indicator) => map.lookup(eq.eqStrict)(indicator, INDICATOR_TO_MESSAGE)),
        option.getOrElse<string | null>(() => null)
      )
    },
    hasIndicatorMessage (): boolean {
      return this.indicatorMessage !== null
    }
  },
  methods: {
    setOtp (value: string) {
      this.$emit('otp', value)
      this.untouchedSinceDispatch = false
    },
    submit () {
      if (!this.hasIndicatorMessage) {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.untouchedSinceDispatch = true
          this.$emit('submit')
        }
      }
    }
  }
})
